export { default } from './Information';
export type { Props, Props as InformationBannerProps } from './Information';
